<template>
  <b-modal id="modal-input-cabang" size="lg" centered title="Tambah Data Cabang" header-bg-variant="primary" header-text-variant="light">
    <b-form>
      <b-form-group label="Nama Cabang" label-cols-md="3">
        <b-form-input autofocus type="text" :state="checkIfValid('namaCabang')" v-model="$v.data.namaCabang.$model"></b-form-input>
      </b-form-group>
      <b-form-group label="Kode Cabang" label-cols-md="3">
        <b-form-input type="text" :state="checkIfValid('kodeCabang')" v-model="$v.data.kodeCabang.$model"></b-form-input>
      </b-form-group>
      <b-form-group label="Nama Mitra" label-cols-md="3">
        <Multiselect
          v-model="$v.data.mitra.$model"
          :state="checkIfValid('mitra')"
          :options="mitra"
          @input="getKoordinator(data.mitra), (data.koordinator = null)"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          label="namaMitra"
          placeholder="-- Pilih --"
        ></Multiselect>
      </b-form-group>
      <b-form-group label="Nama Koordinator" label-cols-md="3">
        <Multiselect
          v-model="$v.data.koordinator.$model"
          :state="checkIfValid('koordinator')"
          :options="koordinator"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          label="namaKoordinator"
          placeholder="-- Pilih --"
        ></Multiselect>
      </b-form-group>
      <b-form-group label="Provinsi" label-cols-md="3">
        <Multiselect
          v-model="$v.data.provinsi.$model"
          :state="checkIfValid('provinsi')"
          :options="provinsi"
          @input="getKota(data.provinsi)"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          label="namaProvinsi"
          track-by="id"
          placeholder="-- Pilih Provinsi --"
        ></Multiselect>
      </b-form-group>

      <b-form-group label="Kota" label-cols-md="3">
        <Multiselect
          v-model="$v.data.kota.$model"
          :state="checkIfValid('kota')"
          :options="kota"
          @input="getKecamatan(data.kota)"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          label="namaKota"
          track-by="idKota"
          placeholder="-- Pilih Kabupaten/Kota --"
        ></Multiselect>
      </b-form-group>

      <b-form-group label="Kecamatan" label-cols-md="3">
        <Multiselect
          v-model="$v.data.kecamatan.$model"
          :state="checkIfValid('kecamatan')"
          :options="kec"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          label="namaKecamatan"
          track-by="kecamatanId"
          placeholder="-- Pilih Kecamatan --"
        ></Multiselect>
      </b-form-group>
      <b-form-group label="Alamat" label-cols-md="3">
        <b-form-input type="text" :state="checkIfValid('alamatCabang')" v-model="$v.data.alamatCabang.$model"></b-form-input>
      </b-form-group>
      <b-form-group label="No. Telp" label-cols-md="3">
        <b-form-input type="number" :state="checkIfValid('noHpKantor')" v-model="$v.data.noHpKantor.$model"></b-form-input>
      </b-form-group>
      <b-form-group label="Latitude" label-cols-md="3">
        <b-form-input type="text" :state="checkIfValid('latitude')" v-model="$v.data.latitude.$model"></b-form-input>
      </b-form-group>
      <b-form-group label="Longtitude" label-cols-md="3">
        <b-form-input type="text" :state="checkIfValid('longitude')" v-model="$v.data.longitude.$model"></b-form-input>
      </b-form-group>
    </b-form>
    <!-- <img :src="src1" /> -->
    <template #modal-footer>
      <b-button variant="secondary" @click="$bvModal.hide('modal-input-cabang')"> Tutup </b-button>
      <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
        {{ button }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["mitra", "provinsi"],
  data() {
    return {
      data: {
        namaCabang: "",
        kodeCabang: "",
        mitra: "",
        provinsi: "",
        koordinator: "",
        kota: "",
        kecamatan: "",
        alamatCabang: "",
        noHpKantor: "",
        longitude: 0,
        latitude: 0,
      },
      kota: [],
      kec: [],
      koordinator: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
    mitra_aktif() {
      return this.$store.state.mitra_aktif;
    },
    koordinator_aktif() {
      return this.$store.state.koordinator_aktif;
    },
  },
  watch: {
    mitra_aktif(newVar, oldVar) {
      if (newVar != oldVar) {
        this.data.mitra = newVar;
      }
    },
    koordinator_aktif(newVar, oldVar) {
      if (newVar != oldVar) {
        this.data.koordinator = newVar;
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      mitra: {
        required,
      },
      koordinator: {
        required,
      },
      provinsi: {
        required,
      },
      kota: {
        required,
      },
      kecamatan: {
        required,
      },
      namaCabang: {
        required,
      },
      kodeCabang: {
        required,
      },
      alamatCabang: {
        required,
      },
      noHpKantor: {
        required,
      },
      longitude: {
        required,
      },
      latitude: {
        required,
      },
    },
  },
  async mounted() {
    this.data.mitra = this.mitra_aktif;
    this.data.koordinator = this.koordinator_aktif;
    this.getKoordinator(this.data.mitra);
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async getKota(x) {
      let kota = await this.$axios.get("kota/listByProvinsiId/" + x.id);
      // console.log(kota);
      this.kota = kota.data.data;
    },
    async getKecamatan(x) {
      console.log(x);
      let kec = await this.$axios.get("kecamatan/listByKotaId/" + x.idKota);
      // console.log(kec);
      this.kec = kec.data.data;
    },
    async getKoordinator(x) {
      let koordinator = await this.$axios.get("koordinator/listKoordinatorByMitraId/" + x.id);
      // console.log(koordinator, "ini koordinator");
      this.koordinator = koordinator.data.data;
      this.data.koordinator = "";
    },
    simpan() {
      let vm = this;
      vm.data.mitraId = vm.data.mitra.id;
      vm.data.koordinatorId = vm.data.koordinator.id;
      vm.data.provinsiId = vm.data.provinsi.id;
      vm.data.kotaId = vm.data.kota.idKota;
      vm.data.kecamatanId = vm.data.kecamatan.kecamatanId;
      vm.$axios
        .post("cabang/register", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN CABANG",
              showing: true,
            });
            this.data.namaCabang = "";
            this.data.kodeCabang = "";
            this.data.alamatCabang = "";
            this.data.noHpKantor = "";
            this.$v.$reset();
            this.$bvModal.hide("modal-input-cabang");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
